import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PaymentsRequests from "./PaymentsRequests";
import Menu from "../../../Layout/Menu/Menu";
import NavBar from "../../../../components/NavBarAdmin";
import Table from "../../../Layout/Table/Table";

const PaymentsList = () => {
  const ActionColumn = ({ id }) => {
    return (
      <div>
        <Link
          to={`/my/admin/payments/${id}/details`}
          className="btn btn-secondary btn-sm"
        >
          <i className="fa-solid fa-eye"></i>&nbsp; Detalhes
        </Link>
      </div>
    );
  };

  const InvoiceCheck = ({ data }) => {
    return data == 1 ? (
      <i className="fa-solid ms-5 fa-xl fa-circle-check"></i>
    ) : (
      <i className="fa-regular ms-5 fa-xl fa-circle"></i>
    );
  };

  const columns = [
    "",
    "venue",
    "numRef",
    "name",
    "date_time",
    "plan_days_period",
    "billing_vat_value",
    "invoice",
    "status",
    "Actions",
  ];

  const serializeRowsColums = () => {
    return data.map((item) => {
      return {
        ...item,
        invoice: <InvoiceCheck data={item.invoice} />,
        Actions: <ActionColumn id={item.id} />,
      };
    });
  };

  const [data, setData] = useState([]);
  useEffect(async () => {
    let info = await PaymentsRequests.getPaymentsList();
    if (info && info.status) {
      setData(info.data.list);
    }
  }, []);

  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-xs-12 dashboard-content">
            <div className="row">
              <div className="col-8">
                <h2 className="dashboard-h2"> Payments List</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-12 event-list-table">
                <Table
                  columns={columns}
                  data={serializeRowsColums(data)}
                  currentPage={1}
                  itemsPerPage={50}
                  totalItems={data.length}
                />
              </div>
            </div>
          </div>
        </div>
      </NavBar>
    </div>
  );
};

export default PaymentsList;
